import Vue from 'vue'
import InputAutocomplete from '../components/input-autocomplete.vue'

Vue.component('InputAutocomplete', InputAutocomplete)
